import { computed, onBeforeUnmount, ref, set } from "@vue/composition-api";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export function usePreventPublish() {
  const uploadState = ref({
    isUploading: false,
    isCancelled: false,
    isCompleted: false,
  });

  const processing = computed(() => uploadState.value.isUploading && !uploadState.value.isCompleted);

  const cancelPostUploadMethods = () => {
    if (processing.value) {
      set(uploadState.value, "isCancelled", true);
    }
  };

  const preventChoosePostType = (cb: () => void) => {
    if (processing.value) {
      cb();
    }
  };

  const resetPreventPublish = () => {
    uploadState.value = { isUploading: false, isCompleted: false, isCancelled: false };
  };

  const watchExecution = async (execution: Promise<any>) => {
    uploadState.value = { isUploading: true, isCancelled: false, isCompleted: false };
    await execution
      .then(() => set(uploadState.value, "isCompleted", true))
      .catch(() => set(uploadState.value, "isCancelled", true))
      .finally(() => set(uploadState.value, "isUploading", false));

    return !uploadState.value.isCancelled;
  };

  useBeforeUnloadTab(processing);

  emitter.on<any>(EVENTS.CHOOSE_POST_TYPE, preventChoosePostType);

  onBeforeUnmount(() => {
    emitter.off<any>(EVENTS.CHOOSE_POST_TYPE, preventChoosePostType);
  });

  return {
    uploadState,
    watchExecution,
    cancelPostUploadMethods,
    resetPreventPublish,
  };
}
